import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'

import { useBrandConfigContext } from '../../../../providers/BrandConfigContext/BrandConfigContext'
import DeliveryEmail from '../../../FulfilmentBox/DeliveryBox/DeliveryEmail/DeliveryEmail'

import { by } from '../../../../utils'
import { doTrack } from '../../../../helpers/taggingSerializer'

const getOutOfStockVariants = (combinations, type, availability, isShortLabels) => {
  const outOfStockVariants = combinations
    .filter(combination => combination.attributes?.find(by.typeOf(type)))
    .map(combination => {
      const { partNumber, attributes } = combination

      const { data = {}, meta = {} } = availability

      const { requestDone, errorDetail } = meta

      const { quantityAvailable = 0 } = data[partNumber] || {}

      const isAvailable = !requestDone
        ? true // Assume availability until request is done
        : errorDetail
        ? true // Return true on error so customer can still add to trolley
        : quantityAvailable > 0
      const { value, shortValue } = attributes?.find(by.typeOf(type))
      const outOfStock = !isAvailable || !partNumber
      return {
        label: isShortLabels ? shortValue : value,
        value: partNumber,
        outOfStock
      }
    })
    .filter(option => option.outOfStock)
    .map(oosOption => ({
      title: oosOption.label,
      value: oosOption.value
    }))

  return outOfStockVariants
}

const SizesBackInStockForm = ({ combinations, type, availability, isShortLabels, isTuMobileLayout }) => {
  const hasAvailabilityLoaded = availability?.meta?.requestDone
  const outOfStockSkus = getOutOfStockVariants(combinations, type, availability, isShortLabels)
  const hasOutOfStockSkus = outOfStockSkus?.length > 0
  const [isClient, setIsClient] = useState(false)

  const { EMAIL_ME_BACK = {} } = useBrandConfigContext()
  const { position = '', trackOnLoad = false } = EMAIL_ME_BACK

  // Tracking for EMBWIS (when the email box is under size selector)
  useEffect(() => {
    setIsClient(true)

    if (hasAvailabilityLoaded && window?.digitalData?.product?.[0]?.attributes) {
      // Update data layer if email box is shown
      window.digitalData.product[0].attributes.emailWhenInStockOffered = hasOutOfStockSkus
      // Track event when the component loads after updating data layer (only on Tu)
      if (trackOnLoad) {
        doTrack('pdp_initialStockAPIs')
      }
    }
  }, [hasAvailabilityLoaded])

  if (position !== 'sizePicker') {
    return null
  }

  if (!isClient) {
    return null
  }

  const portalTarget = document.getElementById('email-portal')

  return (
    <>
      {isTuMobileLayout && portalTarget ? (
        ReactDOM.createPortal(
          <DeliveryEmail
            hasSizePicker
            isAvailabilityLoading={!hasAvailabilityLoaded}
            outOfStockSkus={outOfStockSkus}
            isTuMobileLayout={isTuMobileLayout}
          />,
          portalTarget
        )
      ) : (
        <DeliveryEmail
          hasSizePicker
          isAvailabilityLoading={!hasAvailabilityLoaded}
          outOfStockSkus={outOfStockSkus}
          isTuMobileLayoutt={isTuMobileLayout}
        />
      )}
    </>
  )
}

SizesBackInStockForm.propTypes = {
  /**
   * Prop from state to provide the availability data for all size variants
   */
  availability: PropTypes.object,
  /**
   * All possible products by size
   */
  combinations: PropTypes.array,
  /**
   * Type of product variant ('size')
   */
  type: PropTypes.string,
  /**
   * Boolean to determine whether to use shorter labels for sizes in the selector
   */
  isShortLabels: PropTypes.bool
}

SizesBackInStockForm.defaultProps = {
  availability: {},
  combinations: [],
  type: '',
  isShortLabels: false
}

const mapStateToProps = state => {
  return {
    availability: state?.availability
  }
}

export { SizesBackInStockForm }
export default connect(mapStateToProps)(SizesBackInStockForm)
